import { render, staticRenderFns } from "./Llegada.vue?vue&type=template&id=42ff2210&scoped=true"
import script from "./Llegada.vue?vue&type=script&lang=js"
export * from "./Llegada.vue?vue&type=script&lang=js"
import style0 from "./Llegada.vue?vue&type=style&index=0&id=42ff2210&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42ff2210",
  null
  
)

export default component.exports